import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { FloatingActions } from "@/components/layout/FloatingActions";
import { Chatbot } from "@/components/layout/Chatbot";

export const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-[var(--cdt-bg)]">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <FloatingActions />
    <Chatbot />
  </div>
);
